import { type OrderItemCatalogItemApiModel } from '../api-models/OrderItemCatalogItemApiModel'

/**
 * Each lock folds its absent field to `false` — the response does not carry
 * them yet, so every item reads unlocked until the backend adds them.
 */
export const mapOrderItemCatalogItem = (
  catalogItem: Nullable<OrderItemCatalogItemApiModel>
) =>
  catalogItem
    ? {
        id: catalogItem.id,
        name: catalogItem.name,
        locked: catalogItem.rfo_lock ?? false,
        accountLocked: catalogItem.account_lock ?? false,
        vendorLocked: catalogItem.vendor_lock ?? false,
      }
    : null
